module.exports = __webpack_public_path__ + "static/media/search.312cd45e.svg";